export default __webpack_public_path__ + "static/media/KOD0154-min.3b0a2fef.webp";